import { QueryTuple, useLazyQuery } from '@apollo/client';
import { CrewMemberList } from '@bechtel/types';
import { GET_WELDERS, GET_CREW_MEMBERS_WITH_SUPERVISOR } from '@bechtel/client-gql';

export function useCrewMember(
  fetchFromNetwork?: boolean
): QueryTuple<{ crewMembers: CrewMemberList }, Record<string, any>> {
  const response = useLazyQuery<{ crewMembers: CrewMemberList }>(
    GET_WELDERS,
    fetchFromNetwork
      ? {
          notifyOnNetworkStatusChange: true,
          fetchPolicy: 'network-only',
        }
      : {
          notifyOnNetworkStatusChange: true,
        }
  );
  return response;
}

export function useCrewMemberWithSupervisor(
  fetchFromNetwork?: boolean
): QueryTuple<{ crewMembers: CrewMemberList }, Record<string, any>> {
  const response = useLazyQuery<{
    crewMembers: CrewMemberList;
  }>(
    GET_CREW_MEMBERS_WITH_SUPERVISOR,
    fetchFromNetwork
      ? {
          notifyOnNetworkStatusChange: true,
          fetchPolicy: 'network-only',
        }
      : {
          notifyOnNetworkStatusChange: true,
        }
  );
  return response;
}
